import React, { useState, useEffect } from "react";
import {Modal,Typography, Select, Popover, Form, Input, Descriptions, Badge, Collapse, Table, Button,} from "antd";
import { getRiderDetail } from "../../../../../../services/riders.service";
import RiderBrakeMark from "../riderBrakeMark";
import { PERMISSION_CONSTANT } from "../../../../../../utils/constants/app";
import { userhasPermissionHelper } from "../../../../../../utils/Helpers";
import { connect } from "react-redux";
const { Panel } = Collapse;
const { Text } = Typography;

const ModalEditOrderRider = (props) => {
  const [postDataOrderRider, setPostDataOrderRider] = useState(null);
  const [MBtnLoading, setMBtnLoading] = useState(false);

  useEffect(() => {
    if (props.visible) {
      postLists();
    }
  }, [props.visible]);
  const postLists = async () => {
    try {
      setMBtnLoading(true);
      const resp = await getRiderDetail(props.orderRiderID);
      setPostDataOrderRider(resp.data.data);
      // console.log("Rider detail", resp.data.data, props.orderRiderID);

      // const respshift = await getRiderShift(props.orderRiderID.id);
      // setPostDataOrderRider(respshift.data.data);
      // console.log("Shift", respshift);
    } catch {
      // setErrMsg("Something went wrong");
    } finally {
      setMBtnLoading(false);
    }
  };

  const brake = props.orderRiderID ? (
    <RiderBrakeMark brakeRiderid={props.orderRiderID} />
  ) : (
    ""
  );

  const DeliveriesDetailColumns = [
    { title: "Started at", dataIndex: "estAcceptTime" },
    { title: "Ended at", dataIndex: "estPickupArrival" },
    { title: "Zone", dataIndex: "loc" },
  ];
  const routesColumns = [
    { title: "Delivery", dataIndex: "delivery" },
    {
      title: "Courier",
      render: (rider) => (rider ? <Text>{rider.fullName}</Text> : ""),
      dataIndex: "rider",
    },
    { title: "Action", dataIndex: "Action" },
    { title: "Arr", dataIndex: "arr" },
    { title: "End?", dataIndex: "end" },
  ];

  const handleOkOrderRider = () => {
    props.setvisible(false);
  };
  const handleCancel = () => {
    props.setvisible(false);
  };
  return (
    <Modal
      title="Rider Detail"
      visible={props.visible}
      onCancel={handleCancel}
      footer={[<Button loading={MBtnLoading} onClick={handleCancel}>Cancel</Button>]}
    >
      <Descriptions
        title={postDataOrderRider ? postDataOrderRider.fullName : "-"}
        layout="vertical"
        bordered
      >
        <Descriptions.Item label="Shift status">
          <Popover content={brake} title="Put rider on break/tmp">
            <Badge
              count={postDataOrderRider ? postDataOrderRider.status : "-"}
              style={{
                backgroundColor: "#568733",
              }}
            />
            <a> TMP/BREA</a>
          </Popover>
        </Descriptions.Item>
        <Descriptions.Item label="Vehicle">
          {postDataOrderRider ? postDataOrderRider.vehicle : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Phone">
          {userhasPermissionHelper(
            props.permissions,
            PERMISSION_CONSTANT.VIEW_Rider_PHONE
          )
            ? postDataOrderRider?.phoneNumber || "-"
            : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Balance">
          <Badge
            count={postDataOrderRider && postDataOrderRider.wallet_balance ? `Rs ${postDataOrderRider.wallet_balance}` : "0"}
            style={{backgroundColor: "#FACC06",}}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Fleet ID">
          {postDataOrderRider ? postDataOrderRider.display_id : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Stack orders">no</Descriptions.Item>
        {/* <Descriptions.Item label="Order count">--</Descriptions.Item> */}
        {/* <Descriptions.Item label="Note to rider">
          <Input />
        </Descriptions.Item> */}
      </Descriptions>

      {/* <Collapse accordion> */}
        {/* <Panel header="Shift" key="1">
          <Table
            dataSource={props.postDataOrderRider}
            columns={DeliveriesDetailColumns}
            pagination={false}
          />
        </Panel> */}
        {/* <Panel header="Today’s Order" key="2">
          <Table
            dataSource={props.postDataOrderRider}
            columns={DeliveriesDetailColumns}
            pagination={false}
          />
        </Panel> */}
        {/* <Panel header="Feedback" key="3">
          <Form layout="vertical" name="Reassign-order">
            <Form.Item>
              <Input placeholder="Select Order" />
            </Form.Item>
            <Form.Item>
              <Input placeholder="Reason" />
            </Form.Item>
            <Form.Item>
              <Input placeholder="Comment" />
            </Form.Item>
            <Form.Item>
              <Button>Submit</Button>
            </Form.Item>
          </Form>
        </Panel> */}
        {/* <Panel header="Route" key="4">
          <Table
            dataSource={props.postDataOrderRider}
            columns={routesColumns}
            pagination={false}
          />
        </Panel> */}
        {/* <Panel header="Current location" key="5">
          ?
        </Panel>
      </Collapse> */}
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    permissions: state.PermissionReducer.permissions,
  };
};
export default connect(mapStateToProps)(ModalEditOrderRider);
